interface PanelActions {
    automations: number;
    notifications: number;
    scenes: number;
    schedules: number;
}

export enum ConnectivityStatus {
    NOT_CONFIGUGRED = "Not Configured",
    NOT_CONNECTED = "Not Connected",
    NO_INTERNET = "No Internet",
    ACTIVELY_USING = "Actively Using",
    CONNECTED = "Connected",
    CONFIGURED = "Configured",
}
// type ConnectivityStatus = "not configured" | "not connected" | "no internet" | "connected" | "actively using";
interface ConnectivityGeneric {
    status: ConnectivityStatus;
    ipAddress?: string;
    active?: string;
}

interface WifiConnectivity extends ConnectivityGeneric {
    ssid?: string;
    wifiStrength?: string;
    frequency?: string;
}

interface LTEConnectivity extends ConnectivityGeneric {
    provider?: string;
    signalStrength?: string;
}

interface EthernetConnectivity extends ConnectivityGeneric {
    macAddress?: string;
    subnetMask?: string;
}

export class Connectivity {
    cellular: LTEConnectivity;
    wifi: WifiConnectivity;
    ethernet: EthernetConnectivity;

    constructor(connectivityData: any = {}) {
        this.cellular = connectivityData?.cellular || { status: ConnectivityStatus.NOT_CONFIGUGRED };
        this.wifi = connectivityData?.wifi || { status: ConnectivityStatus.NOT_CONFIGUGRED };
        this.ethernet = connectivityData?.ethernet || { status: ConnectivityStatus.NOT_CONFIGUGRED };
    }
}

export interface PanelDevice {
    offline: number;
    online: number;
    unconfigured: number;
}

export interface PanelSystem {
    hardwarePlatform: string;
    macAddress: string;
    machineSerialNumber: string;
    mprmAppVersion: string;
    timezone: string;
}

export interface Versions {
    clarehome: string;
    hardware: string;
    image: string;
    qtclarehomeagent: string;
    qtupdateservice: string;
}
export interface DisplayTroubleCondition {
    name: string;
    condition: string;
    hyperlink?: string;
}

interface Partition {
    name: string;
    tamperTrouble?: boolean;
    securityMonitoringTrouble?: boolean;
    keyFobTrouble?: boolean;
    keypadTrouble?: boolean;
    wirelessSirenTrouble?: boolean;
    receiverJam?: boolean;
}

interface OfflineDevice {
    name: string;
}

interface LowBattery {
    name: string;
}

interface UnAuthedDevice {
    name: string;
}

interface TamperZone {
    name: string;
}

interface SecuritySensor {
    tamper?: { [zone: string]: TamperZone };
    trouble?: { [zone: string]: TamperZone };
}

export interface PanelTroubleConditions {
    partitions: { [key: string]: Partition };
    lowBattery: { [key: string]: LowBattery };
    offlineDevices: { [key: string]: OfflineDevice };
    unAuthedDevices: { [key: string]: UnAuthedDevice };
    securitySensors: { [key: string]: SecuritySensor };
}

export interface PanelSummary {
    actions: PanelActions;
    connectivity: Connectivity;
    device: PanelDevice;
    system: PanelSystem;
    versions: Versions;
    troubleConditions: PanelTroubleConditions;
}

export const getDefaultPanelSummary = (): PanelSummary => ({
    actions: null,
    connectivity: null,
    device: null,
    system: null,
    versions: null,
    troubleConditions: {
        partitions: null,
        lowBattery: null,
        offlineDevices: null,
        unAuthedDevices: null,
        securitySensors: null,
    },
});

const ON_ACTIVE = "Yes";
export const isActiveUsing = (active: string): boolean => active === ON_ACTIVE;
